<template>
  <div>
    <a class="cursor-pointer text-14" @click="toggleShow">
      {{ $t('cha-kan-xiang-qing') }}
    </a>
    <a-modal
      :open="visible"
      wrapClassName="xmov-normal-modal"
      centered
      width="952px"
      :footer="null"
      :title="$t('cheng-yuan-ge-ren-kong-jian-cun-chu-xiang-qing')"
      @cancel="visible = false"
    >
      <a-table
        class="xmov-table-pagination"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :loading="loading"
        :scroll="{ y: '525px' }"
        @change="handleTableChange"
      >
        <template #bodyCell="{ column, text }">
          <template v-if="column.dataIndex === 'user_info'">
            {{ text?.name }}
          </template>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>

<script lang="ts" setup>
import type { TableProps } from 'ant-design-vue'
import type { ColumnsType } from 'ant-design-vue/es/table/interface'
import { fetchMembersStorage } from '~/api'
import { usePage } from '~/hooks/usePage'
const { $t } = useNuxtApp()
const visible = ref(false)
const columns: ColumnsType = [
  {
    title: $t('cheng-yuan-xing-ming'),
    dataIndex: 'user_info',
  },
  {
    title: $t('he-ji'),
    // width: 100,
    dataIndex: 'total_size',
    customRender: ({ text }) => (text ? getFormateFileSize(text, false) : 0),
    sorter: true,
    defaultSortOrder: 'descend',
  },
  {
    title: $t('zi-yuan'),
    // width: 100,
    dataIndex: 'media_size',
    customRender: ({ text }) => (text ? getFormateFileSize(text, false) : 0),
    sorter: true,
    // defaultSortOrder: 'ascend',
  },
  {
    title: $t('cheng-pian'),
    // width: 100,
    dataIndex: 'task_size',
    customRender: ({ text }) => (text ? getFormateFileSize(text, false) : 0),
    sorter: true,
    // defaultSortOrder: 'ascend',
  },
]

const { list, total, page, page_size, loading, getList, reload } = usePage({
  api: (params) =>
    fetchMembersStorage({
      ...params,
      many: 1,
      // o: '-total_size',
    }),
  pageSize: 10,
})

const pagination = computed<any>(() => ({
  total: total.value,
  current: page.value,
  pageSize: page_size.value,
  showTotal: (total: string) => $t('gong-total-tiao', [total]),
  showSizeChanger: true,
  showQuickJumper: true,
}))

const handleTableChange: TableProps['onChange'] = (p, filters, sorter: any) => {
  page.value = p.current as number
  page_size.value = p.pageSize as number
  getList({
    page: p.current,
    page_size: p.pageSize,
    ...(sorter.order && {
      o: sorter?.order === 'descend' ? `-${sorter.field}` : `${sorter.field}`,
    }),
  })
}

const toggleShow = () => {
  if (!visible.value) {
    getList({
      page: pagination.value.current,
      page_size: pagination.value.pageSize,
      o: '-total_size',
    })
  }
  visible.value = !visible.value
}

// defineExpose({
//   toggleShow,
// })
</script>
